import WriteupForm from './components/WriteupForm.vue';
import AdminWriteups from './components/admin/AdminWriteups.vue';
import AdminChallengeWriteupTemplate from './components/admin/AdminChallengeWriteupTemplate.vue';
import AdminEvaluation from './components/admin/AdminEvaluation.vue';
import AdminHomeStats from './components/admin/AdminHomeStats.vue';

export default {

  install(vue) {
    // Extend admin home
    vue.$ctforge.registerComponent(AdminHomeStats, { type: 'admin_home' });
    // Extend challenge page
    vue.$ctforge.registerComponent(WriteupForm, { type: 'challenge', position: 'bottom' });
    vue.$ctforge.registerComponent(AdminChallengeWriteupTemplate, { type: 'admin_challenge_form', priority: 1 });
    // Admin interface
    vue.$router.addChildrenRoutes('/admin', [
      {
        path: 'writeups',
        component: AdminWriteups,
      },
      {
        name: 'admin_evaluation',
        path: 'evaluation/:challenge_name/:user_id',
        component: AdminEvaluation,
      },
    ]);
    vue.$ctforge.addAdminLinks([
      { name: 'Writeups', path: '/admin/writeups', icon: 'file' },
    ]);
  },
};
